import { usePathname } from 'expo-router';
import { useEffect } from 'react';

import { setCrashlyticsRoute } from '@/src/lib/crashlytics';

export function CrashlyticsTracker() {
  const pathname = usePathname();

  useEffect(() => {
    setCrashlyticsRoute(pathname);
  }, [pathname]);

  return null;
}
